module.exports = __webpack_public_path__ + "static/media/1 封面.f7b9e31d.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/有機椰子糖奶酥醬/1 封面.JPG
// module id = 240
// module chunks = 0